<template>
  <div class="container dk-meus-videos" style="padding-bottom: 68px;">

    <!-- ── Barra de pesquisa ── -->
    <div id="container-filtros-tour" class="dk-search-bar">
      <div class="dk-search-field">
        <span class="dk-search-field__icon">
          <feather-icon icon="SearchIcon" size="15" />
        </span>
        <el-input
          v-model="input"
          placeholder="Pesquisar por nome ou tag..."
          @input="pesquisar"
          class="dk-el-input"
        />
      </div>
    </div>

    <!-- <pre>{{ playerVideos}}</pre>    -->
    <!-- <pre>{{ folders }}</pre>   -->

    <!-- Stats resumo + controles -->
    <div class="dk-videos-toolbar">
      <div class="dk-stats-row">
        <div class="dk-stat-chip">
          <feather-icon icon="VideoIcon" size="14" />
          <span class="dk-stat-chip__val">{{ playerVideos.length }}</span>
          <span class="dk-stat-chip__label">videos</span>
        </div>
        <div class="dk-stat-chip">
          <feather-icon icon="FolderIcon" size="14" />
          <span class="dk-stat-chip__val">{{ folders.length }}</span>
          <span class="dk-stat-chip__label">pastas</span>
        </div>
        <div class="dk-stat-chip">
          <feather-icon icon="EyeIcon" size="14" />
          <span class="dk-stat-chip__val">{{ totalViews }}</span>
          <span class="dk-stat-chip__label">views</span>
        </div>
        <div class="dk-stat-chip">
          <feather-icon icon="PlayIcon" size="14" />
          <span class="dk-stat-chip__val">{{ totalPlays }}</span>
          <span class="dk-stat-chip__label">plays</span>
        </div>
        <div class="dk-stat-chip">
          <feather-icon icon="BarChart2Icon" size="14" />
          <span class="dk-stat-chip__val">{{ avgPlayRate }}%</span>
          <span class="dk-stat-chip__label">play rate</span>
        </div>
      </div>
      <div class="dk-view-toggle">
        <button class="dk-view-btn" :class="{ 'dk-view-btn--active': viewMode === 'list' }" @click="viewMode = 'list'" title="Lista">
          <feather-icon icon="ListIcon" size="16" />
        </button>
        <button class="dk-view-btn" :class="{ 'dk-view-btn--active': viewMode === 'grid' }" @click="viewMode = 'grid'" title="Grid">
          <feather-icon icon="GridIcon" size="16" />
        </button>
      </div>
    </div>

    <section class="dk-section-card dk-section-card--folders">
      <div class="dk-section-card__header">
        <div class="dk-section-card__left">
          <div class="dk-section-card__icon">
            <feather-icon icon="FolderIcon" size="16" />
          </div>
          <div>
            <h3 class="dk-section-card__title">Pastas</h3>
            <p class="dk-section-card__sub">Organize seus vídeos por tema, produto ou campanha</p>
          </div>
        </div>
        <span class="dk-section-card__count">{{ folders.length }}</span>
      </div>
      <folders
        v-model="folders"
        @updateVideos="getPlayerVideos($event)"
        @selectVideoFolder="selectFolderVideo($event)"
      />
    </section>

    <section class="dk-section-card dk-section-card--videos">
      <div class="dk-section-card__header">
        <div class="dk-section-card__left">
          <div class="dk-section-card__icon">
            <feather-icon icon="VideoIcon" size="16" />
          </div>
          <div>
            <h3 class="dk-section-card__title">Videos</h3>
            <p class="dk-section-card__sub">
              Pasta atual: <strong>{{ currentFolderName }}</strong>
            </p>
          </div>
        </div>
        <div style="display:flex;align-items:center;gap:10px;">
          <span class="dk-section-card__count">{{ playerVideos.length }}</span>
          <upload-videos />
        </div>
      </div>
      <videos
        v-model="playerVideos"
        :videos-loading="loadingVideos"
        :view-mode="viewMode"
        @selectVideoFolder="selectFolderVideo($event)"
      />
    </section>

    <BarraCheckBox
      v-model="qtdSelected"
      :checked="isCheckedAll"
      :folders.sync="folders"
      :videos="playerVideos"
      @updatedChecked="inputChecked"
    />
  </div>
</template>
<script>
import BarraCheckBox from '@/components/MenuCheckBox/BarraCheckBox.vue'
import { mapActions, mapState } from 'vuex'
import { useApi } from '@/composables/useApi'
import clearFolderOnExit from '@/mixins/clearFolderOnExit'

import { BInputGroup, BFormInput, BInputGroupPrepend } from 'bootstrap-vue'
import Videos from './Videos.vue'
import Folders from '../Pastas/Folders.vue'
import ModalCriarPastas from '../Pastas/ModalCriarPastas.vue'
import UploadVideos from '@/components/uploadVideos.vue'

const api = useApi()
export default {
  components: {
    ModalCriarPastas,
    Folders,
    Videos,
    BarraCheckBox,
    UploadVideos,
    BInputGroup,
    BFormInput,
    BInputGroupPrepend,

  },
  mixins: [clearFolderOnExit],
  data() {
    return {
      input: '',
      isCheckedAll: false,
      qtdSelected: [],
      folders: [],
      loadingVideos: true,
      viewMode: localStorage.getItem('videos_view_mode') || 'list',
      // playerVideos: [],
      // playerVideos: []
    }
  },
  computed: {
    ...mapState('Folders', ['folderAtual']),

    getUserData() {
      return JSON.parse(localStorage.getItem('userData'))
    },
    playerVideos() {
      return this.$store.state.Videos.AllVideosMain
    },
    totalViews() {
      return this.playerVideos.reduce((sum, v) => sum + (parseInt(v.qtde_load) || 0), 0)
    },
    totalPlays() {
      return this.playerVideos.reduce((sum, v) => sum + (parseInt(v.qtde_play) || 0), 0)
    },
    avgPlayRate() {
      if (!this.totalViews) return '0'
      return ((this.totalPlays / this.totalViews) * 100).toFixed(1)
    },
    currentFolderName() {
      if (this.folderAtual && this.folderAtual.folder_name) return this.folderAtual.folder_name
      return 'Meus Videos'
    },
  },
  watch: {
    viewMode(val) {
      localStorage.setItem('videos_view_mode', val)
    },
  },
  beforeDestroy() {
    // Zerar folderATUAL quando o componente for destruído
    localStorage.setItem('folderATUAL', JSON.stringify(0))
    this.$store.commit('Folders/setfolderAtual', {
      id: 0,
      folder_name: 'Meus Videos',
      folder_backet_adress: null,
      id_main: null,
      id_user: this.getUserData.id,
      folder_date: null,
      folder_key_name: null,
    })
  },
  beforeRouteLeave(to, from, next) {
    // Zerar folderATUAL quando sair da rota
    localStorage.setItem('folderATUAL', JSON.stringify(0))
    this.$store.commit('Folders/setfolderAtual', {
      id: 0,
      folder_name: 'Meus Videos',
      folder_backet_adress: null,
      id_main: null,
      id_user: this.getUserData.id,
      folder_date: null,
      folder_key_name: null,
    })
    next()
  },
  methods: {
    //  ...mapActions('Videos', ['listarVideos']),
    ...mapActions('Folders', ['getAllFolderUser']),
    inputChecked(val) {
      this.isCheckedAll = val
    },
    selectFolderVideo(item) {
      if (this.qtdSelected.indexOf(item) === -1) {
        this.qtdSelected.push(item)
      } else {
        this.qtdSelected.splice(this.qtdSelected.indexOf(item), 1)
      }
    },
    setFolderATUAL() {
      const atual = 0
      localStorage.setItem('folderATUAL', JSON.stringify(atual))
    },
    async getFoldersAll() {
      const params = {
        id_main: 0,
      }
      await api.get(`/folderUser/${this.getUserData.id}`, {
        params,
      })
        .then(resp => {
          const formData = resp.data
          formData.map(f => f.is_selected = false)
          this.folders = formData
        })
    },
    async getPlayerVideos(id_folder) {
      this.isCheckedAll = false
      this.qtdSelected = []
      this.loadingVideos = true
      let params = null
      if (id_folder) {
        params = {
          id_folder: id_folder.id,
        }
      }
      try {
        const resp = await api.get(`/vslUserId/${this.getUserData.id}`, { params })
        const formData = resp.data
        formData.map(v => v.is_selected = false)
        this.$store.commit('Videos/setVideosMain', formData)
      } finally {
        this.loadingVideos = false
      }
    },

    async pesquisar(e) {
      const idMain = this.folders.length === 0 ? this.folderAtual.id : this.folders[0].id_main
      const userId = this.getUserData.id
      const [byName, byTag, byFolder] = await Promise.all([
        api.get(`/getVslLike?vsl_name=${e}&id_user=${userId}&id_folder=${idMain}`),
        api.get(`/getTagVslLike?vsl_tag=${e}&id_user=${userId}&id_folder=${idMain}`),
        api.get(`/getFolderLike?folder_name=${e}&id_user=${userId}&id_main=${idMain}`),
      ])
      const merged = [...(byName.data || []), ...(byTag.data || [])]
      const seen = new Set()
      const deduped = merged.filter(v => {
        if (seen.has(v.id)) return false
        seen.add(v.id)
        return true
      })
      this.$store.commit('Videos/setVideosMain', deduped)
      this.folders = byFolder.data || []
    },
  },
  mounted() {
    this.getAllFolderUser()
    this.getFoldersAll(0)
    this.getPlayerVideos({
      id: 0,
    })
    this.setFolderATUAL()
    this.$store.commit('appHelperTour/SET_TYPE_HELPER_TOUR', 'meus-videos')
  },
}
</script>

<style lang="scss" scoped>
$dk-navy:   #0D3349;
$dk-orange: #E86A10;

// ── Videos toolbar (stats + view toggle) ──────────
.dk-videos-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  gap: 12px;
  flex-wrap: wrap;
}
.dk-stats-row {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.dk-stat-chip {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 8px;
  background: var(--dk-bg-card, #fff);
  border: 1px solid var(--dk-border, #e2e8f0);
  font-size: 12px;
  color: var(--dk-text-muted, #8a94a6);
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
}
.dk-stat-chip__val {
  font-weight: 800;
  color: var(--dk-text-primary, #0D3349);
  font-size: 13px;
}
.dk-stat-chip__label {
  font-weight: 500;
}
.dk-view-toggle {
  display: flex;
  gap: 2px;
  background: var(--dk-bg-segment, #f0f3f7);
  border-radius: 8px;
  padding: 3px;
}
.dk-view-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border: none;
  background: transparent;
  color: var(--dk-text-muted, #8a94a6);
  cursor: pointer;
  transition: all 0.15s;
}
.dk-view-btn:hover { color: var(--dk-text-primary, #0D3349); }
.dk-view-btn--active {
  background: var(--dk-bg-card, #fff);
  color: #E86A10;
  box-shadow: 0 1px 4px rgba(0,0,0,0.08);
}

// ── Section cards ─────────────────────────────────
.dk-section-card {
  background: rgba(255,255,255,0.02);
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 14px;
  padding: 12px;
  margin-bottom: 14px;
}

.dk-section-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 6px 6px 12px;
}

.dk-section-card__left {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.dk-section-card__icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #E86A10;
  background: rgba(232,106,16,0.12);
  border: 1px solid rgba(232,106,16,0.2);
  flex-shrink: 0;
}

.dk-section-card__title {
  margin: 0;
  font-size: 0.9rem;
  color: var(--dk-text-primary, #e2e8f0);
  font-weight: 700;
}

.dk-section-card__sub {
  margin: 2px 0 0;
  font-size: 0.76rem;
  color: var(--dk-text-muted, rgba(255,255,255,.45));
}

.dk-section-card__count {
  font-size: 0.72rem;
  font-weight: 700;
  color: #E86A10;
  background: rgba(232,106,16,0.12);
  border: 1px solid rgba(232,106,16,0.25);
  border-radius: 99px;
  padding: 3px 10px;
}

// ── Search bar ────────────────────────────────────
.dk-search-bar {
  display: flex;
  gap: 12px;
  margin-bottom: 18px;
  flex-wrap: wrap;
}

.dk-search-field {
  display: flex;
  align-items: center;
  gap: 0;
  background: var(--dk-bg-card, #fff);
  border: 1px solid var(--dk-border, #e4eaee);
  border-radius: 10px;
  overflow: hidden;
  flex: 1;
  min-width: 200px;
  transition: border-color 0.2s, box-shadow 0.2s;
  box-shadow: 0 1px 3px rgba($dk-navy, 0.04);

  &:focus-within {
    border-color: $dk-orange;
    box-shadow: 0 0 0 3px rgba($dk-orange, 0.1);
  }

  &__icon {
    padding: 0 10px 0 14px;
    color: var(--dk-text-faint, #b0bac4);
    display: flex;
    align-items: center;
    flex-shrink: 0;
    transition: color 0.2s;
  }

  &:focus-within &__icon {
    color: $dk-orange;
  }
}

// Neutraliza estilos padrão do el-input dentro do wrapper
.dk-search-field ::v-deep .el-input__inner {
  border: none !important;
  box-shadow: none !important;
  padding-left: 4px !important;
  height: 40px;
  font-size: 0.85rem;
  color: $dk-navy;
  background: transparent;

  &::placeholder {
    color: var(--dk-text-faint, #b8c2cc);
  }
}

.dk-search-field ::v-deep .el-input__suffix {
  display: none;
}
</style>
